import type { ImprovementOrigin } from '@zeus/index'
import type { ImprovementAction } from '~/gql/quality/quality'
import { ImprovementStatus } from '@zeus/index'
import { toDayInput } from '~/helpers/dates/session-dates'

/** Le formulaire d'une action d'amélioration (#328), en texte tel que saisi. */
export type ActionForm = {
  origin: ImprovementOrigin | ''
  title: string
  description: string
  owner: string
  /** `YYYY-MM-DD`, vide sans échéance. */
  dueDate: string
  status: ImprovementStatus
  effect: string
}

export function actionForm(action: ImprovementAction | undefined, timeZone?: string | null): ActionForm {
  return {
    origin: action?.origin ?? '',
    title: action?.title ?? '',
    description: action?.description ?? '',
    owner: action?.owner ?? '',
    dueDate: action?.dueDate ? toDayInput(action.dueDate, timeZone) : '',
    status: action?.status ?? ImprovementStatus.PLANNED,
    effect: action?.effect ?? '',
  }
}

export function isActionFormValid(form: ActionForm): boolean {
  return !!form.origin && !!form.title.trim() && !!form.description.trim()
}
